<template>
  <div
    ref="splide"
    class="main-slider splide splide__dark"
  >
    <div class="splide__track">
      <div class="splide__list">
        <div
          v-for="(slide, index) in data"
          :key="index"
          class="splide__slide"
        >
          <div
            class="gallery-item"
            tabindex="-1"
            role="group"
            :aria-label="slide.title || 'Gallery item'"
          >
            <img
              :src="slide.image"
              :alt="slide.title || 'Gallery item'"
            >
            <div class="content">
              <h3 class="title">
                {{ slide.title }}
              </h3>
              <p class="description">
                {{ slide.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splide from '@splidejs/splide';
import { setupSplide } from '../../../js/global';

export default {
  name: 'ImageGallery',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    this.initSlider();
  },
  methods: {
    initSlider() {
      const splideElement = this.$refs.splide;
      if (!splideElement) return;

      const slideCount = this.data.length;
      if (slideCount === 0) return;

      const options = {
        type: 'loop',
        rewind: true,
        perPage: 3,
        perMove: 1,
        pagination: true,
        gap: 16,
        drag: true,
        arrows: false,
        autoplay: true,
        interval: 5000,
        breakpoints: {
          1530: {
            perPage: 2,
          },
          1220: {
            perPage: 1,
          },
          1024: {
            perPage: 2,
          },
          706: {
            perPage: 1,
          },
        },
      };

      this.mainSplide = new Splide(splideElement, options);
      setupSplide(this.mainSplide);

      this.mainSplide.on('visible', (slideComponent) => {
        const card = slideComponent.slide.querySelector('.gallery-item');
        if (card) card.setAttribute('tabindex', '0');
      });

      this.mainSplide.on('hidden', (slideComponent) => {
        const card = slideComponent.slide.querySelector('.gallery-item');
        if (card) card.setAttribute('tabindex', '-1');
      });

      this.mainSplide.mount();
    },
  },
};
</script>
